// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   ОНЛАЙН-ТАБЛО - КОМПЛЕКСНЫЙ CSS
   Pulkovo Air - Культурные крылья России
   ============================================ */

/* ----- ОСНОВНЫЕ СТИЛИ ----- */
.liveboard {
  background: white;
  border-radius: 24px;
  padding: 20px;
  margin: 30px 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  border: 1px solid #E5E7EB;
}

/* ----- ЗАГОЛОВОК ----- */
.liveboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #F59E0B;
}

.liveboard-title {
  font-size: 22px;
  font-weight: 700;
  color: #1E3A8A;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.liveboard-title i {
  color: #F59E0B;
  font-size: 24px;
}

.liveboard-update {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #6B7280;
}

.refresh-btn {
  background: none;
  border: none;
  color: #1E3A8A;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.refresh-btn:hover {
  background: #F3F4F6;
  transform: rotate(180deg);
  color: #F59E0B;
}

.data-source-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
}

.data-source-badge.db {
  background: #EFF6FF;
  color: #1E3A8A;
}

.data-source-badge.live {
  background: #D1FAE5;
  color: #10B981;
}

/* ===== ДЕСКТОПНАЯ ТАБЛИЦА ===== */
.desktop-table {
  display: block;
}

.liveboard-table-container {
  overflow-x: auto;
  border-radius: 16px;
}

.liveboard-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.liveboard-table th,
.liveboard-table td {
  padding: 14px 12px;
  text-align: left;
  border-bottom: 1px solid #E5E7EB;
}

.liveboard-table th {
  background: #F8FAFC;
  font-weight: 700;
  color: #1E3A8A;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.flight-row:hover {
  background: #F9FAFB;
}

/* Номер рейса */
.flight-number {
  font-family: monospace;
  font-weight: 700;
  font-size: 15px;
  color: #1E3A8A;
  white-space: nowrap;
}

.codeshare-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  background: #F3F4F6;
  color: #6B7280;
  margin-left: 8px;
}

/* ===== ОПЕРАТОРЫ (как в расписании аэропорта) ===== */
.operator-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.operator-PLK {
  background: #EFF6FF;
  color: #1E3A8A;
  border-left: 3px solid #1E3A8A;
}

.operator-VKO {
  background: #FEF3E8;
  color: #B45309;
  border-left: 3px solid #F59E0B;
}

.operator-VIM {
  background: #ECFDF5;
  color: #0D9488;
  border-left: 3px solid #0D9488;
}

.operator-CARGO {
  background: #F5F3FF;
  color: #7C3AED;
  border-left: 3px solid #7C3AED;
}

.operator-TRAVEL {
  background: #FDF2F8;
  color: #DB2777;
  border-left: 3px solid #DB2777;
}

.operator-SDM {
  background: #FEF2F2;
  color: #DC2626;
  border-left: 3px solid #DC2626;
}

/* Аэропорты */
.airport-name {
  font-weight: 600;
  color: #1F2937;
  font-size: 14px;
}

/* ===== ТИП ВОЗДУШНОГО СУДНА ===== */
.flight-aircraft {
  min-width: 100px;
}

.aircraft-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 600;
  font-family: monospace;
  background: #F3F4F6;
  color: #4B5563;
  border: 1px solid #E5E7EB;
}

.aircraft-unknown {
  color: #9CA3AF;
  font-size: 12px;
}

/* ===== СТАТУСЫ ===== */
.flight-status {
  min-width: 130px;
}

.status-badge {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
}

.status-in-air .status-badge,
.status-badge.in-air {
  background: #FEF3E8;
  color: #F59E0B;
  border: 1px solid #FDE68A;
}

.status-booked .status-badge,
.status-badge.booked {
  background: #EFF6FF;
  color: #1E3A8A;
  border: 1px solid #BFDBFE;
}

.status-completed .status-badge,
.status-badge.completed {
  background: #D1FAE5;
  color: #10B981;
  border: 1px solid #A7F3D0;
}

.flight-time {
  font-family: monospace;
  font-size: 12px;
  color: #6B7280;
  white-space: nowrap;
}

/* ===== МОБИЛЬНЫЕ КАРТОЧКИ ===== */
.mobile-liveboard-list {
  display: none;
  flex-direction: column;
  gap: 15px;
}

.mobile-flight-card {
  background: #F9FAFB;
  border-radius: 16px;
  padding: 15px;
  border: 1px solid #E5E7EB;
  transition: all 0.2s ease;
}

.mobile-flight-card:active {
  transform: scale(0.98);
  background: #F3F4F6;
}

/* Заголовок карточки */
.mobile-flight-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E5E7EB;
}

.mobile-flight-number {
  font-family: monospace;
  font-weight: 800;
  font-size: 16px;
  color: #1E3A8A;
  background: #EFF6FF;
  padding: 5px 12px;
  border-radius: 25px;
  display: inline-block;
}

.mobile-codeshare-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  background: #F3F4F6;
  color: #6B7280;
  margin-left: 8px;
}

.mobile-flight-status {
  flex-shrink: 0;
}

.status-badge-mobile {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
}

.status-badge-mobile.in-air {
  background: #FEF3E8;
  color: #F59E0B;
  border: 1px solid #FDE68A;
}

.status-badge-mobile.booked {
  background: #EFF6FF;
  color: #1E3A8A;
  border: 1px solid #BFDBFE;
}

.status-badge-mobile.completed {
  background: #D1FAE5;
  color: #10B981;
  border: 1px solid #A7F3D0;
}

/* Оператор в карточке */
.mobile-operator {
  margin-bottom: 12px;
}

/* Маршрут в карточке */
.mobile-route {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 10px;
  background: white;
  border-radius: 12px;
}

.mobile-airport {
  flex: 1;
  text-align: center;
}

.mobile-airport-label {
  font-size: 10px;
  color: #9CA3AF;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.mobile-airport-name {
  font-weight: 600;
  color: #1E3A8A;
  font-size: 13px;
  line-height: 1.3;
}

.mobile-route-arrow {
  color: #F59E0B;
  font-size: 16px;
  padding: 0 10px;
}

/* Тип ВС в карточке */
.mobile-aircraft {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  background: white;
  border-radius: 12px;
  margin: 10px 0;
  font-size: 12px;
  font-weight: 600;
  color: #1E3A8A;
}

.mobile-aircraft i {
  color: #F59E0B;
  font-size: 14px;
}

/* Время в карточке */
.mobile-flight-time {
  text-align: center;
  padding-top: 10px;
  border-top: 1px solid #E5E7EB;
  font-family: monospace;
  font-size: 12px;
  color: #6B7280;
}

.mobile-flight-time i {
  color: #F59E0B;
  margin-right: 6px;
}

/* ===== СОСТОЯНИЯ ===== */
.liveboard-loading {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 24px;
  margin: 30px 0;
}

.liveboard-loading .spinner {
  width: 50px;
  height: 50px;
  border: 3px solid #E5E7EB;
  border-top-color: #1E3A8A;
  border-right-color: #F59E0B;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

.liveboard-error {
  text-align: center;
  padding: 40px 20px;
  background: #FEF2F2;
  border-radius: 16px;
  color: #B91C1C;
}

.liveboard-error i {
  font-size: 40px;
  margin-bottom: 12px;
}

.retry-btn {
  background: #1E3A8A;
  color: white;
  border: none;
  padding: 8px 24px;
  border-radius: 30px;
  margin-top: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.retry-btn:hover {
  background: #F59E0B;
  color: #1E3A8A;
}

.liveboard-empty {
  text-align: center;
  padding: 60px 20px;
  color: #9CA3AF;
}

.liveboard-empty i {
  font-size: 48px;
  margin-bottom: 15px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ===== АДАПТИВНОСТЬ ===== */
@media (max-width: 768px) {
  .desktop-table {
    display: none !important;
  }
  
  .mobile-liveboard-list {
    display: flex !important;
  }
  
  .liveboard {
    padding: 15px;
    margin: 20px 0;
  }
  
  .liveboard-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .liveboard-title {
    font-size: 20px;
  }
  
  .liveboard-title i {
    font-size: 22px;
  }
  
  .liveboard-update {
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .mobile-flight-number {
    font-size: 14px;
    padding: 4px 10px;
  }
  
  .mobile-airport-name {
    font-size: 12px;
  }
  
  .status-badge-mobile {
    font-size: 10px;
    padding: 3px 10px;
  }
  
  .operator-badge {
    font-size: 10px;
    padding: 3px 8px;
  }
  
  .mobile-route {
    padding: 8px;
  }
  
  .mobile-route-arrow {
    font-size: 14px;
    padding: 0 6px;
  }
  
  .mobile-aircraft {
    font-size: 11px;
    padding: 8px;
  }
  
  .mobile-aircraft i {
    font-size: 12px;
  }
  
  .mobile-flight-time {
    font-size: 11px;
  }
}

@media (max-width: 360px) {
  .liveboard {
    padding: 12px;
  }
  
  .mobile-flight-card {
    padding: 12px;
  }
  
  .mobile-flight-number {
    font-size: 12px;
  }
  
  .mobile-airport-name {
    font-size: 11px;
  }
  
  .mobile-route {
    flex-direction: column;
    gap: 8px;
  }
  
  .mobile-route-arrow {
    transform: rotate(90deg);
    padding: 5px 0;
  }
  
  .mobile-aircraft {
    font-size: 10px;
  }
}

.flight-row.clickable:hover {
  background: #EFF6FF;
  cursor: pointer;
  transition: background 0.2s;
}

.mobile-flight-card.clickable:active {
  transform: scale(0.98);
}`, "",{"version":3,"sources":["webpack://./react/components/LiveBoard.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* ============================================\n   ОНЛАЙН-ТАБЛО - КОМПЛЕКСНЫЙ CSS\n   Pulkovo Air - Культурные крылья России\n   ============================================ */\n\n/* ----- ОСНОВНЫЕ СТИЛИ ----- */\n.liveboard {\n  background: white;\n  border-radius: 24px;\n  padding: 20px;\n  margin: 30px 0;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n  border: 1px solid #E5E7EB;\n}\n\n/* ----- ЗАГОЛОВОК ----- */\n.liveboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #F59E0B;\n}\n\n.liveboard-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1E3A8A;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.liveboard-title i {\n  color: #F59E0B;\n  font-size: 24px;\n}\n\n.liveboard-update {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 12px;\n  color: #6B7280;\n}\n\n.refresh-btn {\n  background: none;\n  border: none;\n  color: #1E3A8A;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.refresh-btn:hover {\n  background: #F3F4F6;\n  transform: rotate(180deg);\n  color: #F59E0B;\n}\n\n.data-source-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.data-source-badge.db {\n  background: #EFF6FF;\n  color: #1E3A8A;\n}\n\n.data-source-badge.live {\n  background: #D1FAE5;\n  color: #10B981;\n}\n\n/* ===== ДЕСКТОПНАЯ ТАБЛИЦА ===== */\n.desktop-table {\n  display: block;\n}\n\n.liveboard-table-container {\n  overflow-x: auto;\n  border-radius: 16px;\n}\n\n.liveboard-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px;\n}\n\n.liveboard-table th,\n.liveboard-table td {\n  padding: 14px 12px;\n  text-align: left;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.liveboard-table th {\n  background: #F8FAFC;\n  font-weight: 700;\n  color: #1E3A8A;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.flight-row:hover {\n  background: #F9FAFB;\n}\n\n/* Номер рейса */\n.flight-number {\n  font-family: monospace;\n  font-weight: 700;\n  font-size: 15px;\n  color: #1E3A8A;\n  white-space: nowrap;\n}\n\n.codeshare-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n  background: #F3F4F6;\n  color: #6B7280;\n  margin-left: 8px;\n}\n\n/* ===== ОПЕРАТОРЫ (как в расписании аэропорта) ===== */\n.operator-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.operator-PLK {\n  background: #EFF6FF;\n  color: #1E3A8A;\n  border-left: 3px solid #1E3A8A;\n}\n\n.operator-VKO {\n  background: #FEF3E8;\n  color: #B45309;\n  border-left: 3px solid #F59E0B;\n}\n\n.operator-VIM {\n  background: #ECFDF5;\n  color: #0D9488;\n  border-left: 3px solid #0D9488;\n}\n\n.operator-CARGO {\n  background: #F5F3FF;\n  color: #7C3AED;\n  border-left: 3px solid #7C3AED;\n}\n\n.operator-TRAVEL {\n  background: #FDF2F8;\n  color: #DB2777;\n  border-left: 3px solid #DB2777;\n}\n\n.operator-SDM {\n  background: #FEF2F2;\n  color: #DC2626;\n  border-left: 3px solid #DC2626;\n}\n\n/* Аэропорты */\n.airport-name {\n  font-weight: 600;\n  color: #1F2937;\n  font-size: 14px;\n}\n\n/* ===== ТИП ВОЗДУШНОГО СУДНА ===== */\n.flight-aircraft {\n  min-width: 100px;\n}\n\n.aircraft-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 16px;\n  font-size: 11px;\n  font-weight: 600;\n  font-family: monospace;\n  background: #F3F4F6;\n  color: #4B5563;\n  border: 1px solid #E5E7EB;\n}\n\n.aircraft-unknown {\n  color: #9CA3AF;\n  font-size: 12px;\n}\n\n/* ===== СТАТУСЫ ===== */\n.flight-status {\n  min-width: 130px;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 5px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.status-in-air .status-badge,\n.status-badge.in-air {\n  background: #FEF3E8;\n  color: #F59E0B;\n  border: 1px solid #FDE68A;\n}\n\n.status-booked .status-badge,\n.status-badge.booked {\n  background: #EFF6FF;\n  color: #1E3A8A;\n  border: 1px solid #BFDBFE;\n}\n\n.status-completed .status-badge,\n.status-badge.completed {\n  background: #D1FAE5;\n  color: #10B981;\n  border: 1px solid #A7F3D0;\n}\n\n.flight-time {\n  font-family: monospace;\n  font-size: 12px;\n  color: #6B7280;\n  white-space: nowrap;\n}\n\n/* ===== МОБИЛЬНЫЕ КАРТОЧКИ ===== */\n.mobile-liveboard-list {\n  display: none;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.mobile-flight-card {\n  background: #F9FAFB;\n  border-radius: 16px;\n  padding: 15px;\n  border: 1px solid #E5E7EB;\n  transition: all 0.2s ease;\n}\n\n.mobile-flight-card:active {\n  transform: scale(0.98);\n  background: #F3F4F6;\n}\n\n/* Заголовок карточки */\n.mobile-flight-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.mobile-flight-number {\n  font-family: monospace;\n  font-weight: 800;\n  font-size: 16px;\n  color: #1E3A8A;\n  background: #EFF6FF;\n  padding: 5px 12px;\n  border-radius: 25px;\n  display: inline-block;\n}\n\n.mobile-codeshare-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 10px;\n  background: #F3F4F6;\n  color: #6B7280;\n  margin-left: 8px;\n}\n\n.mobile-flight-status {\n  flex-shrink: 0;\n}\n\n.status-badge-mobile {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.status-badge-mobile.in-air {\n  background: #FEF3E8;\n  color: #F59E0B;\n  border: 1px solid #FDE68A;\n}\n\n.status-badge-mobile.booked {\n  background: #EFF6FF;\n  color: #1E3A8A;\n  border: 1px solid #BFDBFE;\n}\n\n.status-badge-mobile.completed {\n  background: #D1FAE5;\n  color: #10B981;\n  border: 1px solid #A7F3D0;\n}\n\n/* Оператор в карточке */\n.mobile-operator {\n  margin-bottom: 12px;\n}\n\n/* Маршрут в карточке */\n.mobile-route {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  padding: 10px;\n  background: white;\n  border-radius: 12px;\n}\n\n.mobile-airport {\n  flex: 1;\n  text-align: center;\n}\n\n.mobile-airport-label {\n  font-size: 10px;\n  color: #9CA3AF;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.mobile-airport-name {\n  font-weight: 600;\n  color: #1E3A8A;\n  font-size: 13px;\n  line-height: 1.3;\n}\n\n.mobile-route-arrow {\n  color: #F59E0B;\n  font-size: 16px;\n  padding: 0 10px;\n}\n\n/* Тип ВС в карточке */\n.mobile-aircraft {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px;\n  background: white;\n  border-radius: 12px;\n  margin: 10px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1E3A8A;\n}\n\n.mobile-aircraft i {\n  color: #F59E0B;\n  font-size: 14px;\n}\n\n/* Время в карточке */\n.mobile-flight-time {\n  text-align: center;\n  padding-top: 10px;\n  border-top: 1px solid #E5E7EB;\n  font-family: monospace;\n  font-size: 12px;\n  color: #6B7280;\n}\n\n.mobile-flight-time i {\n  color: #F59E0B;\n  margin-right: 6px;\n}\n\n/* ===== СОСТОЯНИЯ ===== */\n.liveboard-loading {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 24px;\n  margin: 30px 0;\n}\n\n.liveboard-loading .spinner {\n  width: 50px;\n  height: 50px;\n  border: 3px solid #E5E7EB;\n  border-top-color: #1E3A8A;\n  border-right-color: #F59E0B;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 15px;\n}\n\n.liveboard-error {\n  text-align: center;\n  padding: 40px 20px;\n  background: #FEF2F2;\n  border-radius: 16px;\n  color: #B91C1C;\n}\n\n.liveboard-error i {\n  font-size: 40px;\n  margin-bottom: 12px;\n}\n\n.retry-btn {\n  background: #1E3A8A;\n  color: white;\n  border: none;\n  padding: 8px 24px;\n  border-radius: 30px;\n  margin-top: 15px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.retry-btn:hover {\n  background: #F59E0B;\n  color: #1E3A8A;\n}\n\n.liveboard-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: #9CA3AF;\n}\n\n.liveboard-empty i {\n  font-size: 48px;\n  margin-bottom: 15px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ===== АДАПТИВНОСТЬ ===== */\n@media (max-width: 768px) {\n  .desktop-table {\n    display: none !important;\n  }\n  \n  .mobile-liveboard-list {\n    display: flex !important;\n  }\n  \n  .liveboard {\n    padding: 15px;\n    margin: 20px 0;\n  }\n  \n  .liveboard-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .liveboard-title {\n    font-size: 20px;\n  }\n  \n  .liveboard-title i {\n    font-size: 22px;\n  }\n  \n  .liveboard-update {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 480px) {\n  .mobile-flight-number {\n    font-size: 14px;\n    padding: 4px 10px;\n  }\n  \n  .mobile-airport-name {\n    font-size: 12px;\n  }\n  \n  .status-badge-mobile {\n    font-size: 10px;\n    padding: 3px 10px;\n  }\n  \n  .operator-badge {\n    font-size: 10px;\n    padding: 3px 8px;\n  }\n  \n  .mobile-route {\n    padding: 8px;\n  }\n  \n  .mobile-route-arrow {\n    font-size: 14px;\n    padding: 0 6px;\n  }\n  \n  .mobile-aircraft {\n    font-size: 11px;\n    padding: 8px;\n  }\n  \n  .mobile-aircraft i {\n    font-size: 12px;\n  }\n  \n  .mobile-flight-time {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 360px) {\n  .liveboard {\n    padding: 12px;\n  }\n  \n  .mobile-flight-card {\n    padding: 12px;\n  }\n  \n  .mobile-flight-number {\n    font-size: 12px;\n  }\n  \n  .mobile-airport-name {\n    font-size: 11px;\n  }\n  \n  .mobile-route {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .mobile-route-arrow {\n    transform: rotate(90deg);\n    padding: 5px 0;\n  }\n  \n  .mobile-aircraft {\n    font-size: 10px;\n  }\n}\n\n.flight-row.clickable:hover {\n  background: #EFF6FF;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.mobile-flight-card.clickable:active {\n  transform: scale(0.98);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
